import { Box, Heading } from '@wix/design-system';
import * as React from 'react';
import HomePageHeaderImage from '../../../assets/images/home-page-header';
import { SearchBox } from '@wix/app-market-components';
import {
  useEssentials,
  AppMarketPage,
  useTranslation,
  useSiteContext,
} from '@wix/app-market-core';
import { useSearchBoxActions } from '../../../components/search-box/hooks/search-box-actions';
import s from './header.scss';

export function HomePageHeader() {
  const { experiments } = useEssentials();
  const { languageCode } = useSiteContext();
  const { t } = useTranslation();
  const { onSelect, onChange, onFocus, onEnterPressed } = useSearchBoxActions(
    AppMarketPage.HOMEPAGE,
    'search-bar-homepage',
  );

  return (
    <Box className={s.headerContainer} align="space-between">
      <Box className={s.header} direction="vertical" gap="6px" maxWidth="718px">
        <Box maxWidth="570px" marginTop="18px">
          <Heading size="extraLarge" dataHook="page-title">
            {t('home.page.title')}
          </Heading>
        </Box>
        <Box marginTop="12px">
          <SearchBox
            dataHook="search-box-home-page"
            onChange={onChange}
            onSelect={onSelect}
            onEnterPressed={onEnterPressed}
            onFocus={onFocus}
            languageCode={languageCode}
            experiments={experiments}
            size="large"
          />
        </Box>
      </Box>
      <div className={s.homePageHeaderImage}>
        <HomePageHeaderImage />
      </div>
    </Box>
  );
}
